export const Masks = {
    CUBE_3: {
        LAST_LAYER: {
            F: [3, 4, 5, 6, 7, 8],
            B: [3, 4, 5, 6, 7, 8],
            R: [3, 4, 5, 6, 7, 8],
            L: [3, 4, 5, 6, 7, 8],
            D: [0, 1, 2, 3, 4, 5, 6, 7, 8],
        },
        F2L: {
            F: [0, 1, 2],
            B: [0, 1, 2],
            R: [0, 1, 2],
            L: [0, 1, 2],
            U: [0, 1, 2, 3, 4, 5, 6, 7, 8],
        },
        FIRST_LAYER: {
            F: [0, 1, 2, 3, 4, 5],
            B: [0, 1, 2, 3, 4, 5],
            R: [0, 1, 2, 3, 4, 5],
            L: [0, 1, 2, 3, 4, 5],
            U: [0, 1, 2, 3, 4, 5, 6, 7, 8],
        },
        OLL: {
            R: [0, 1, 2, 3, 4, 5, 6, 7, 8],
            F: [0, 1, 2, 3, 4, 5, 6, 7, 8],
            D: [0, 1, 2, 3, 4, 5, 6, 7, 8],
            L: [0, 1, 2, 3, 4, 5, 6, 7, 8],
            B: [0, 1, 2, 3, 4, 5, 6, 7, 8],
        },
        CORNERS_LAST_LAYER: {
            U: [1, 3, 5, 7],
            F: [1, 3, 4, 5, 6, 7, 8],
            B: [1, 3, 4, 5, 6, 7, 8],
            R: [1, 3, 4, 5, 6, 7, 8],
            L: [1, 3, 4, 5, 6, 7, 8],
            D: [0, 1, 2, 3, 4, 5, 6, 7, 8],
        },
        EDGES_LAST_LAYER: {
            U: [0, 2, 6, 8],
            F: [0, 2, 3, 4, 5, 6, 7, 8],
            B: [0, 2, 3, 4, 5, 6, 7, 8],
            R: [0, 2, 3, 4, 5, 6, 7, 8],
            L: [0, 2, 3, 4, 5, 6, 7, 8],
            D: [0, 1, 2, 3, 4, 5, 6, 7, 8],
        },
    },
    MEGA_3: {
        OLL: {
            F: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            R: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            L: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            BR: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            BL: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            d: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            b: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            dl: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            dr: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            bl: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            br: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        },
    },
};
